const MainPageContainer = ({ children, className }: { children: any; className?: string }) => {
  return (
    <div
      id="MainPageContainer"
      className={`flex flex-col gap-2 m-3 justify-between ${className ?? ""}`}
    >
      {children}
    </div>
  );
};

export default MainPageContainer;
